'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SENT = exports.SENT = 'SENT';
var FAILED = exports.FAILED = 'FAILED';